module.exports = __webpack_public_path__ + "static/media/latest-img-2.ed726b60.jpg";